import { Route, Routes } from "react-router-dom";
import PublicRouter from "./PublicRouter";
import PrivateRouter from "./PrivateRouter";
import { RoutesLink } from "../ApiHelper/RoutesLink";
import App from "../App";
import Projects from "../Pages/Projects";
import Framework from "../Pages/Framework";
import RolePermission from "../Pages/RolePermission/RolePermission";
import Settings from "../Pages/Settings";
import AiBuddy from "../Pages/AiBuddy";
import Policy from "../Pages/Policy";
import LoginPage from "../Pages/auth/Login";
import Dashboard from "../Pages/Dashboard/Dashboard";
import ControlsView from "../Pages/Controls/ControlsView";
import RisksPage from "../Pages/Risks";
import ReportsView from "../Pages/Report/ReportsView";
import TeamView from "../Pages/TeamView/TeamView";
import TeamManagementView from "../Pages/TeamManagementView";
import Organization from "../Pages/Organization";

const MainRoute = () => {
    const basename = "/";
    return (
        <div>
            <Routes>
                <Route basename={basename} element={<PublicRouter />}>
                    <Route path={RoutesLink.login} element={<LoginPage />} />
                </Route>
                <Route basename={basename} element={<PrivateRouter />}>
                    {/* <Route path={'/dashboard'} element={<App />} /> */}
                    <Route path={RoutesLink.aiBuddy} element={<AiBuddy />} />
                    <Route path={RoutesLink.dashboard} element={<Dashboard />} />
                    {/* <Route path={RoutesLink.dashboard} element={<App />} /> */}
                    <Route path={RoutesLink.controls} element={<ControlsView/>} />
                    <Route path={RoutesLink.risks} element={<RisksPage/>} />
                    <Route path={RoutesLink.policy} element={<Policy />} />
                    <Route path={RoutesLink.reports} element={<ReportsView />} />
                    <Route path={RoutesLink.teamMember} element={<TeamView/>} />
                    <Route path={RoutesLink.frameworks} element={<Framework />} />
                    <Route path={RoutesLink.rolesPermission} element={<RolePermission />} />
                    <Route path={RoutesLink.team} element={<TeamManagementView />} />
                    <Route path={RoutesLink.projects} element={<Projects />} />
                    <Route path={RoutesLink.organization} element={<Organization />} />
                    <Route path={RoutesLink.settings} element={<Settings />} />
                </Route>
            </Routes>
        </div>
    );
    return (
        <>
            <Routes>
                <Route>
                    <Route path="/" element={<LoginPage />} />
                </Route>
                <Route element={<PrivateRouter />}>
                    <Route path={'/dashboard'} element={<App />} />
                    <Route path={RoutesLink.dashboard} element={<Dashboard />} />
                    <Route path={RoutesLink.aiBuddy} element={<AiBuddy />} />
                    <Route path={RoutesLink.dashboard} element={<App />} />
                    <Route path={RoutesLink.controls} element={<></>} />
                    <Route path={RoutesLink.policy} element={<Policy />} />
                    <Route path={RoutesLink.reports} element={<></>} />
                    <Route path={RoutesLink.team} element={<></>} />
                    <Route path={RoutesLink.frameworks} element={<Framework />} />
                    <Route path={RoutesLink.rolesPermission} element={<RolePermission />} />
                    <Route path={RoutesLink.projects} element={<Projects />} />
                    <Route path={RoutesLink.teamMember} element={<></>} />
                    <Route path={RoutesLink.settings} element={<Settings />} />
                </Route>
            </Routes>
        </>
    );
}

export default MainRoute;